import React from 'react';
import PropTypes from 'prop-types';
import { BetPromo } from '../BetPromo';
import { useSportConfig } from '../../hooks/useSportConfig';
import * as Styled from './styles';

const InRunningState = ({
    title,
    eventName,
    bettingEnabled,
    promotionsConfig
}) => {
    const { config } = useSportConfig();

    return (
        <Styled.ContentWrapper>
            <Styled.Title>{title} SWEEPSTAKE</Styled.Title>
            <Styled.Text>
                It looks like you haven&apos;t entered the {title} Sweepstake
                competition.
            </Styled.Text>
            <Styled.Text>
                The <Styled.Strong>{eventName}</Styled.Strong>{' '}
                {config.labels.eventNoun} is now{' '}
                <Styled.Strong>in-running</Styled.Strong>. Please check back
                later for the results.
            </Styled.Text>
            {bettingEnabled && (
                <Styled.BetPromoWrapper>
                    <BetPromo promotionsConfig={promotionsConfig} />
                </Styled.BetPromoWrapper>
            )}
        </Styled.ContentWrapper>
    );
};
InRunningState.propTypes = {
    title: PropTypes.string.isRequired,
    eventName: PropTypes.string.isRequired,
    bettingEnabled: PropTypes.bool.isRequired,
    promotionsConfig: PropTypes.shape({
        enabled: PropTypes.bool,
        href: PropTypes.string,
        img: PropTypes.shape({
            mobile: PropTypes.string,
            desktop: PropTypes.string
        })
    }).isRequired
};

export default InRunningState;
